import { render, staticRenderFns } from "./MainLogin.vue?vue&type=template&id=7f21a9ff&"
import script from "./MainLogin.vue?vue&type=script&lang=js&"
export * from "./MainLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7f21a9ff', component.options)
    } else {
      api.reload('7f21a9ff', component.options)
    }
    module.hot.accept("./MainLogin.vue?vue&type=template&id=7f21a9ff&", function () {
      api.rerender('7f21a9ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Login/MainLogin.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/MainLogin.vue
// module id = q0WY
// module chunks = 0